import React, { useState } from "react"
import { List, Label, Value } from "components/Ui/List/List"

import { ReactComponent as AttributeIcon } from "images/icons/square-list.svg"
import { Arrow, AttributeItem, Block, Tab } from "./ProductVariantCustomAttributes.styled"
type Props = {
  // eslint-disable-next-line
  customAttributes: any
  insideEditSidebar?: boolean
}

export const ProductVariantCustomAttributes = ({ customAttributes, insideEditSidebar }: Props) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  return (
    <>
      <Tab onClick={() => setExpanded(!expanded)} $expanded={expanded}>
        <AttributeIcon />
        {insideEditSidebar ? <h4>Custom attributes</h4> : <h2>Custom attributes</h2>}
        <Arrow $expanded={expanded} />
      </Tab>
      {expanded && (
        <Block>
          <List>
            {Object.keys(customAttributes).length > 0 ? (
              customAttributes &&
              Object.keys(customAttributes)?.map((key) => (
                <AttributeItem key={key}>
                  <Label>
                    <>{key}:</>
                  </Label>
                  <Value>{customAttributes[key]}</Value>
                </AttributeItem>
              ))
            ) : (
              <p>No attributes set</p>
            )}
          </List>
        </Block>
      )}
    </>
  )
}
